import { alpha as n } from "./atoms-v21098.js";
import { percent as t } from "./atoms-v2960.js";
import { sanitize as r } from "./atoms-v2959.js";
import { isColorString as i, splitColor as e } from "./atoms-v21107.js";
const u = {
  test: /* @__PURE__ */ i("hsl", "hue"),
  parse: /* @__PURE__ */ e("hue", "saturation", "lightness"),
  transform: ({ hue: o, saturation: s, lightness: a, alpha: m = 1 }) => "hsla(" + Math.round(o) + ", " + t.transform(r(s)) + ", " + t.transform(r(a)) + ", " + r(n.transform(m)) + ")"
};
export {
  u as hsla
};
